/* eslint-disable import/prefer-default-export */
import type { IClientOptions } from '@rready/sdk';
import { useAuthStore } from '../store/authStore';

const enableMock = process.env.VUE_APP_MOCK === 'true';

export const SdkOptions: IClientOptions = {
  mock: enableMock,
  baseUrl: `${process.env.VUE_APP_API_URL}`,
  contextOptions: {
    getAppId: () => process.env.VUE_APP_APP_NAME ?? '',
    getContext: () => window.localStorage.getItem('piniaContext') ?? '',
    getProduct: () => window.localStorage.getItem('piniaProductId') ?? '',
    getToken: () => useAuthStore().token?.raw ?? ''
  },
  handlerOptions: {
    onAuthError: (message: string) => {
      console.error(`Auth error: ${message}`);
    },
    onClientError: (message: string) => {
      console.error(`Client error: ${message}`);
    },
    onServerError: (message: string) => {
      console.error(`Server error: ${message}`);
    },
    onError: (message: string) => {
      console.error(`Generic error: ${message}`);
    }
  }
};
